import utils from 'utils'

export default class Vehicle {
    constructor() {
        const userInfo = JSON.parse(localStorage.getItem('user_info'))
        this.params = {
            adValoremTotal: '0.00', // 价税合计
            applicant: '', // 申请人
            applyReason: '', // 申请理由
            sourceCode: '', // 红字信息表主键id，如果非红字专票则为空
            billNum: 0, // 关联销售单数
            blueAdValoremTotal: 0,
            blueInvoiceCode: '',
            blueInvoiceNumber: '',
            blueTaxAmt: 0,
            blueTotalAmt: 0,
            busSysId: 0,
            busSysName: '',
            checker: '', // 复核人
            createUser: userInfo.user.userName, // 创建人名称
            creditType: '1', // 购方企业类型,01(企业);02(机关事业单位);03(个人);04(其它)电子发票需要 购方信息内获取到
            custAddress: '', // 购方地址
            custBank: '', // 购方开户银行
            // custBankAccount: '',    // 购方银行账号
            custCode: '', // 购方编码
            custCreditCode: '', // 购方纳税人信用代码
            custMobile: '', // 购方手机
            custName: '', // 购方名称
            // custPhone: '',          // 购方电话
            description: '', // 描述
            diskCode: '', // 开票服务器（金税盘）编号
            diskId: 0, // 开票服务器（金税盘）ID，需根据编号回填
            extendInfo: '', // 特殊行业类型发票定制的内容，使用json存储
            industryCode: '', // 行业代码
            industryName: '', // 行业名称
            invType: '12', // 发票种类,0(专票);2(普票);41(卷式票);51(电子票);12(机动车发票)
            invoiceCode: '', // 发票代码(开具税控发票号回写)
            invoiceNumber: '', // 发票号码(开具税控发票号回写)
            invoiceResultDesc: '', // 开票结果描述
            invoiceSource: '1', // 发票来源,1(开票申请单);3(单据-Excel);4(单据-Txt);5(单据-中间表);6(单据-业务接口);7(开票软件)
            isBlueList: '',
            isChineseSecurity: userInfo.sale.isChineseSecurity, // 是否开具汉字防伪发票,0(否);1(是)
            isInvoice: '0', // 是否开票,0(未开);1(已开);2(重开)
            isList: '0', // 是否清单,0(否);1(是)
            isLock: '', // 是否锁定,0(否);1(是)
            isRed: '0', // 是否红票,
            isUpdate: '',
            isValid: '',
            matName: '', // 主商品名称
            openPeople: userInfo.user.realName, // 开具人
            operationCode: '', // 操作代码,电子发票需要,10 (正票正常开具);11( 正票错票重开);20( 退货折让红票);21( 错票重开红票);22( 换票冲红(全冲红电子发票,开具纸质发票)) ,
            payee: '', // 收款人
            projectId: 0, // 项目ID
            projectName: '', // 项目名称
            redInfoNumber: '', // 红字信息表编号
            remark: '', // 开票备注
            rushRedReason: '', // 冲红原因，电子发票冲红时需要
            saleAddress: userInfo.sale.registerAddress,
            salePhone: userInfo.sale.phone,
            saleBank: userInfo.sale.saleBankAccount.bank,
            saleBankAccount: userInfo.sale.saleBankAccount.bankAccount,
            saleCreditCode: userInfo.sale.saleCreditCode,
            saleId: userInfo.sale.saleId,
            saleName: userInfo.sale.saleName,
            specialRedFlag: '', // 特殊冲红标志,0(正常冲红);1(特殊冲红)电子发票冲红时需要 ,
            state: '', //  1-有效 0-已删除
            taxRate: '', // 税率
            tenantId: 0, // 租户ID
            totalAmt: '0.00', // 合计金额(不含税)
            totalTaxamt: '0.00', // 合计税额
            ukeyCode: '', // 开票点编号
            ukeyId: 0, // 开票点ID,需根据编号回填
            updateUser: '', // 修改人名称
            isTax: '1', // 是否含税,0(否);1(是)
            waitId: '', // 待开编号
            waitInvoiceStatus: '', // 待开发票状态，参考数据字典
            vehicleInvoice: {
                certificateNumber: '', // 合格证号
                checkNumber: '', //  商检单号
                createTime: '', //  创建时间 ,
                createUser: '', //  创建人名称 ,
                engineNumber: '', //  发动机号码 ,
                factoryModel: '', //  厂牌型号 ,
                importIdNumber: '', //  进口证明书号 ,
                limitPeople: '', //  限乘人数 ,
                mainSaleCode: '', //  主管税务机关代码 ,
                mainSaleName: '', //  主管税务机关名称 ,
                manufacturer: '', //  生产企业名称 ,
                manufacturerCode: '', //  生产企业代码 ,
                placeOfOrigin: '', //  产地 ,
                placeOfOriginCode: '', //  产地代码(可选) ,
                state: 1, //  1-有效 0-已删除
                taxCertificateNumber: '', //  完税凭证号码 ,
                tonnage: '', //  吨位 ,
                updateTime: '', //  修改时间 ,
                updateUser: '', //  修改人名称 ,
                vehicleNumber: '', //  车辆识别代码/车架代码 ,
                vehicleType: '', //  车辆类型 ,
                vehicleTypeCode: '', //  车辆类型编码 ,  ****  传值
                waitId: '', //  待开编号
            },
            waitDetailList: [{
                adValoremTotal: 0, // 价税合计
                amount: 0, // 金额  小写  根据蓝票 红冲 正负
                invoiceId: '', // 待开编号
                isPrivilege: '', //
                isTax: '', // 根据税率，税率>0取1，税率为0取0
                lineNature: '0',
                matCode: '', // vehicleTypeCode  ****  传值
                matName: '', // vehicleType
                price: 0, //  金额 小写  一定是正数
                privilegeType: '', //  优惠类型
                quantity: 0, // 1 / -1
                revenueCode: '', // 税分编码 carinfo
                revenueName: '', // 税收分类编码 名称  carinfo TaxClassName
                revenueVersion: '', // 版本号
                serialNo: 1,
                shortAndMatName: '', // vehicleType
                taxAmount: 0, // 税额  根据蓝票 红冲 正负
                taxPrice: 0, // 税额   一定是正数
                taxRate: 0, // 税率
                tenantId: 0,
            }],
            custIdentifyNo: '', //  购方身份证/组织机构代码
            hardwareNo: '', //  金税盘硬件编号
        }
        this.taxRateArr = []
    }

    set $setUkeyDiskInfo(_ukeyList0) {
        this.params.ukeyId = _ukeyList0.ukeyId
        this.params.ukeyCode = _ukeyList0.ukeyCode
        this.params.diskCode = _ukeyList0.diskCode
        this.params.diskId = _ukeyList0.diskId
    }

    // 计算中文/英文字符长度
    lengthForString(temp) {
        let len = 0
        temp = $.trim(temp)
        for (let i = 0; i < temp.length; i += 1) {
            const c = temp.charCodeAt(i)
            // 单字节加1
            if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                len += 1
            } else {
                len += 2
            }
        }
        return len
    }

    // 校验规则
    basicCheck($scope, quota) {
        const invoice = $scope.param
        if (!invoice.ukeyCode) {
            return '请选择开票点'
        }
        if ($.trim(invoice.custName).length === 0) {
            return '购买方名称为空，请重新输入'
        }
        if ($.trim(invoice.custIdentifyNo).length === 0) {
            return '身份证号码/组织机构代码为空，请重新输入'
        }
        if ($.trim(invoice.custIdentifyNo).length !== 0 && (!/^[\dA-Z]*$/.test($.trim(invoice.custIdentifyNo)))) {
            return '身份证号码/组织机构代码格式不正确，请重新输入'
        }
        // if (($.trim(invoice.custCreditCode).length !== 0) && !/^[\dA-Z]{9,20}$/.test($.trim(invoice.custCreditCode))) {
        //     return '纳税人识别号格式不正确，请重新输入'
        // }
        if ($.trim(invoice.vehicleInvoice.vehicleType).length === 0) {
            return '车辆类型为空，请重新选择'
        }
        if ($.trim(invoice.vehicleInvoice.factoryModel).length === 0) {
            return '厂牌编号为空，请重新输入'
        }
        if ($.trim(invoice.vehicleInvoice.placeOfOrigin).length === 0) {
            return '产地为空，请重新输入'
        }
        if (invoice.salePhone && !utils.regExpTest(invoice.salePhone, 'uglyPhone')) {
            return '销方电话不符合规则，请重新输入'
        }
        if (invoice.saleBankAccount && !utils.regExpTest(invoice.saleBankAccount, 'bankCard')) {
            return '销方银行账号不符合规则，请重新输入'
        }
        if ($.trim(invoice.vehicleInvoice.limitPeople).length !== 0 && (!/^[1-9]*[1-9][0-9]*$/.test($.trim(invoice.vehicleInvoice.limitPeople)))) {
            return '限乘人数不符合规则，请重新输入'
        }
        if ($.trim(invoice.vehicleInvoice.vehicleNumber).length !== 0 && (!/^[\dA-Za-z0-9\s\*]*$/.test($.trim(invoice.vehicleInvoice.vehicleNumber)))) {
            return '车架号码格式不正确，请重新输入'
        }
        // 红冲规则
        if ($scope.redVehicleInv && $.trim(invoice.blueInvoiceCode).length === 0) {
            return '蓝票代码为空，请重新输入'
        }
        if ($scope.redVehicleInv && $.trim(invoice.blueInvoiceNumber).length === 0) {
            return '蓝票号码为空，请重新输入'
        }

        if ($scope.redVehicleInv && !/^\d{12}$/.test($.trim(invoice.blueInvoiceCode))) {
            return '蓝票代码格式不正确，请重新输入'
        }
        if ($scope.redVehicleInv && !/^\d{8}$/.test($.trim(invoice.blueInvoiceNumber))) {
            return '蓝票号码格式不正确，请重新输入'
        }

        if (invoice.adValoremTotal > quota) {
            return '发票票面金额超过机动车发票限额'
        }
        return ''
    }
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/model/Vehicle.js